<template>
    <v-dialog
        v-model       = "show"
        max-width     = "600"
        class         = "white"
        :scrollable   = "false"
        content-class = "dialog-border"
        persistent
        no-click-animation
    >
        <div class="pt-2 pb-1 white" style="position: relative">
            <div class="close-button v-flex">
                <c-toolbar-button
                    size     = "26"
                    color    = "primary"
                    icon     = "mdi-refresh"
                    :tooltip = "$t('common.refresh')"
                    @click   = "onRefreshConfirmation"
                />
                <c-toolbar-button
                    class    = "ml-3"
                    size     = "28"
                    color    = "red"
                    icon     = "mdi-close"
                    :tooltip = "$t('common.close')"
                    @click   = "onCancel"
                />
            </div>
            <div class="ml-4 mt-1 w-100" >
                <div style="position: relative; width: calc(50% - 16px)">
                    <div class="w-100">
                        <input
                            v-model = "search"
                            class   = "lm-border search-field"
                            @input  = "onSearch"
                        />
                    </div>
                    <div style="position: absolute; right: 10px; top: 10px">
                        <v-icon size="22" color="lightgray">mdi-magnify</v-icon>
                    </div>
                </div>
            </div>
            <v-expand-transition>
                <v-card height="165" v-if="showRefresh" class="ma-4 ">
                    <v-card-text class="text-center mb-0 pb-0" v-html="$t('msd.customer.responsibles.refresh.info')">
                    </v-card-text>
                    <v-card-actions class="confirm-actions">
                        <v-btn
                            class  = "dialog-button mr-0"
                            @click = "onCancel"
                            depressed
                        >
                            {{ $t('common.no') }}
                        </v-btn>
                        <v-btn
                            class  = "dialog-button primary pl-3 pr-3"
                            @click = "onRefresh"
                            depressed
                        >
                            {{ $t('common.yes') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-expand-transition>

            <v-divider class="mt-3 mb-1" />
            <div class="ml-4 mr-1 mb-2">
                <c-card-iterator
                    :show-title ="false"
                    :items  = "filtered"
                    :height = 500
                    :item-height = "32"
                >
                    <template v-slot:card="{ item }">
                        <c-customer-responsibility-card
                            :area         = "item.area"
                            :responsibles = "customer.responsibles"
                            :selected     = "item.user"
                            @changed      = "onSelected"
                        />
                    </template>
                </c-card-iterator>
            </div>
        </div>
    </v-dialog>
</template>

<script>

import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import Customer from "@/modules/msd/company/customer/service/Customer";
import CCardIterator from "@/modules/core/components/utils/CCardIterator.vue";
import Core from "@/modules/core/service/Core";
import CCustomerResponsibilityCard
    from "@/modules/msd/company/customer/components/controlls/CCustomerResponsibilityCard.vue";

export default {
    name: "DCustomerResponsibilities",

    components: {
        CCustomerResponsibilityCard,
        CCardIterator,
        CToolbarButton
    },

    props: {
        value: {

        },

        customer: {

        }
    },

    data: () => ({
        show: false,
        responsibilities: null,
        filtered: null,
        search: null,
        showRefresh: false
    }),

    mounted() {
        this.show = this.value;
    },

    watch: {
        value () {
            this.showRefresh = false;
            this.show = this.value;
            if (this.show) {
                this.load ();
            }
        }
    },

    methods: {
        load () {
            this.showRefresh = false;
            this.responsibilities = null;
            Customer.responsibilities.load(this.customer.id).then (data => {
                this.responsibilities = data;
                this.onSearch();
            });


        },

        onSearch () {
            if (!this.search) {
                this.filtered = this.responsibilities;
                return;
            }

            this.filtered = this.responsibilities.filter (f => Core.filter.includes(f.filter, this.search));
        },

        onSelected (item) {
            const index = this.responsibilities.findIndex(r => r.area === item.area);
            if (index >= 0) {
                this.responsibilities[index].user = item.user;
                Customer.responsibilities.store(this.customer.id, item);
            }
        },

        onRefreshConfirmation () {
            this.showRefresh = true;
        },

        onRefresh () {
            Customer.responsibilities.refresh(this.customer.id).then((data) => {
                this.responsibilities = data;
                this.onSearch();
            });
        },

        onCancel () {
            this.$emit("input", false);
        }
    }
}
</script>

<style scoped>

.close-button {
    position: absolute;
    z-index: 10;
    right: 16px;
    top: 20px;
}

.confirm-actions {
    margin-left: auto;
    margin-right: auto;
    width: 75%;
}

.search-field {
    margin-top: 8px !important;
    padding-top: 4px!important;
    padding-bottom: 4px;
    padding-left: 8px;
    padding-right: 4px;
    font-size: 14px;
    width: 100%;
}

::v-deep .v-text-field.v-text-field--solo.v-input--dense>.v-input__control {
    min-height: 30px;
}

::v-deep  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
    box-shadow: none;
    border-style: solid;
    border-color: lightgray;
    padding-right: 4px;
    padding-left: 4px;
    padding-top: 2px;
    padding-bottom: 2px;
}

</style>